module.exports = __webpack_public_path__ + "static/img/Dylan-Patterson.65b1f59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dylan-Patterson.jpg
// module id = N5+3
// module chunks = 0